import React from "react";

import * as AllIcons from "../../common/Icons/Icons";
import styles from "./IconGallery.module.css";

interface IconItem {
  name: string;
  component: React.ReactElement;
}

const IconGallery: React.FC = () => {
  const iconsAgg: IconItem[] = Object.entries(AllIcons).map(([key, value]) => ({name: key, component: React.createElement(value)}))


  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Icon Gallery</h1>
      <div className={styles.grid}>

        {iconsAgg.map((icon) => (
          <div key={icon.name} className={styles.iconCard}>
            <div className={styles.iconWrapper}>{icon.component}</div>
            <p className={styles.iconName}>{icon.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default IconGallery;
